
















import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class Heading extends Slide {
  get id() {
    return 'heading-' + this.section.SubType;
  }

  get hasLogo() {
    switch (this.section.SubType) {
      case 'preClosingMeeting_thisYear':
      case 'preClosingMeeting_remaining':
      case 'preClosingMeeting_future':
      case 'preClosingMeeting_schedule':
      case 'preClosingMeeting_misc':
      case 'preClosingMeeting_feedback':
      case 'preClosingMeeting_nextMeeting':
        return false;
    }

    return true;
  }

  get title() {
    if (this.section.Title) {
      return this.section.Title;
    }
    switch (this.section.SubType) {
      case 'cashflow': return 'Kassaflödesanalys';
      case 'overview': return 'Översikt';
      case 'profitloss': return 'Resultaträkning';
      case 'balance': return 'Balansräkning';
      case 'compass': return 'Bolagskompass';
      case 'yearend': return 'Bokslut';
      case 'competition': return 'Konkurrentjämförelse';
      case 'gtAdvisory': return 'Vår rådgivning';
      case 'completion': return 'Avslutning';
      case 'sustainability': return 'Hållbarhet';
      case 'analysis_conditions': return 'Förutsättningar';
      case 'analysis_analysis': return 'Jämförelse';
      case 'analysis_summary': return 'Summering';
      case 'analysis_nextstep': return 'Nästa steg';
      case 'preClosingMeeting_thisYear': return 'Året hittills';
      case 'preClosingMeeting_remaining': return 'Helårsprognos';
      case 'preClosingMeeting_future': return 'Ägarplanering';
      case 'preClosingMeeting_schedule': return 'Tidplan';
      case 'preClosingMeeting_misc': return 'Övrigt';
      case 'preClosingMeeting_feedback': return 'Feedback';
      case 'preClosingMeeting_nextMeeting': return 'Nästa möte';
    }
    return '';
  }
}
